import devAvatarPreviewPage from './Preview'

export default devAvatarPreviewPage
